import {Card, Col, List, Radio, Row} from 'antd';
import moment from 'moment';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import ActiveIcon from '../../assets/icons/ActiveIcon.png';
import BusyIcon from '../../assets/icons/BusyIcon.png';
import coldIcon from '../../assets/icons/coldIcon.png';
import DidntPickCallIcon from '../../assets/icons/DidntPickCallIcon.png';
import NotInterestedIcon from '../../assets/icons/NotInterestedIcon.png';
import OutOfTownIcon from '../../assets/icons/OutOfTownIcon.png';
import followUpsIcon from '../../assets/icons/registration/followUpsIcon.png';
import Request from '../../request';
import {getUrlPushWrapper} from "../../routes";
import styles from './styles.less';
import { RightsWrapper } from '../_utils/utils';


const data = [
    {name: 'Group A', value: 525},
    {name: 'Group B', value: 175}
];

const COLORS = ['#56BFEE', '#69ccf9'];

class FollowUpsTotal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: 'lastMonth',
            visaStatusCount: {visaFillings: []},
            drawer: false,
            drawerParam: {},
            leadIndividualCount:[],
            tutionFeePendings:{},
            tutionFeePaids:{},
            untouchLeads: {}
        }
    }

    async componentDidMount() {
        this.loadAllApis();
    }

    loadAllApis = () => {
        let localUser = JSON.parse(localStorage.getItem('user'))
        let params = {user: localUser._id,}
        Request.getFollowupsData(params).then(({data: followupDataCount}) => {
            this.setState({followupDataCount})
        })
    }

    componentWillReceiveProps(props) {
        const {timer} = this.props;
        if (props.timer !== timer) {
            this.loadAllApis();
        }
    }

    render() {
        const {dispatch} = this.props;

        const {
            followupDataCount,
        } = this.state

        return (
            <div>
                <div className="site-card-wrapper">
                    <RightsWrapper myRight={'followupsTotal.view'}>
                            <Card title={
                                <span>
                                    <img src={followUpsIcon} alt="Smiley face" height="22" width="22"/>
                                    <span style={{paddingLeft: '10px'}}>Followups Total ({followupDataCount && followupDataCount.totalFollowupCount ? followupDataCount.totalFollowupCount : 0})</span>
                                </span>
                            }
                            headStyle={{
                                backgroundColor: '#6d6d6d',
                                color: 'white',
                                minHeight: '11px',
                                fontSize: '17px'
                            }}
                            bordered={false}
                            style={{marginTop: '10px', height: '145px'}}>
                                <Row> 
                                    <Col span={3}> 
                                        <Row>
                                            <Col span={3}>
                                                <img src={ActiveIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Active</div>
                                                {followupDataCount && followupDataCount.activeCount != 0 ? <a onClick={() => {
                                                    dispatch(
                                                        getUrlPushWrapper('followUp.follow', {followUpType: 'Active'})
                                                    )
                                                }}>
                                                    <div className={styles.followupsNumber}
                                                            style={{color: '#8ac545'}}>{followupDataCount && followupDataCount.activeCount}</div>
                                                </a> : <div className={styles.followupsNumber}
                                                            style={{color: '#8ac545'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={DidntPickCallIcon} alt="Smiley face"height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Didn't Pick Call</div>
                                                {
                                                    followupDataCount && followupDataCount.pickCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Didn\'t Pick up Call'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: 'orange'}}>
                                                                {followupDataCount && followupDataCount.pickCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber}style={{color: 'orange'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={BusyIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Busy(Call Later)</div>
                                                {
                                                    followupDataCount && followupDataCount.busyCallCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Busy, Call Later'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#5dc294'}}>
                                                                {followupDataCount && followupDataCount.busyCallCount}
                                                            </div>
                                                        </a> 
                                                    :
                                                        <div className={styles.followupsNumber} style={{color: '#5dc294'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                    <Col span={5}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={NotInterestedIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Not Interested</div>
                                                {
                                                    followupDataCount && followupDataCount.notInterestedCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Not Interested'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}>
                                                                {followupDataCount && followupDataCount.notInterestedCount}
                                                            </div>
                                                        </a> 
                                                    : 
                                                        <div className={styles.followupsNumber} style={{color: '#8e8e8e'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={4}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={OutOfTownIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Out of Town</div>
                                                {
                                                    followupDataCount && followupDataCount.outOfTownCount != 0 ?
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Out Of town'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#607d8b'}}>
                                                                {followupDataCount && followupDataCount.outOfTownCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#607d8b'}}> 0</div>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={2}> 
                                        <Row>
                                            <Col span={3}> 
                                                <img src={coldIcon} alt="Smiley face" height="22" width="22"></img>
                                            </Col>
                                            <Col>
                                                <div className={styles.followupsVisa}>Cold</div>
                                                {
                                                    followupDataCount && followupDataCount.coldCount != 0 ? 
                                                        <a onClick={() => {
                                                            dispatch(
                                                                getUrlPushWrapper('followUp.follow', {followUpType: 'Cold'})
                                                            )
                                                        }}>
                                                            <div className={styles.followupsNumber} style={{color: '#0b91d3'}}>
                                                                {followupDataCount && followupDataCount.coldCount}
                                                            </div>
                                                        </a> 
                                                    : <div className={styles.followupsNumber} style={{color: '#0b91d3'}}> 0</div>
                                                }
                                            </Col>
                                        </Row> 
                                    </Col>
                                </Row>
                            </Card>
                    </RightsWrapper>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(mapDispatchToProps)
(FollowUpsTotal)

//export default Dashboard
